import classNames from 'classnames';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { MaterialIcon } from 'shared/ui/MaterialIcon';
import { Tooltip } from 'shared/ui/Tooltip';

interface AddEmailProps {
  inputsCount: number;
  isLoading: boolean;
  onClick: () => void;
}

const EMAILS_LIMIT = 20;

export function AddEmail({ inputsCount, onClick, isLoading }: AddEmailProps) {
  const isLimitReached = inputsCount === EMAILS_LIMIT;

  const addEmailButton = (
    <div
      onClick={() => {
        !isLimitReached && onClick();
      }}
      className={classNames(
        'select-none align-center mt-5 mb-32 flex cursor-pointer gap-2 px-5 font-semibold text-deep-blue-500',
        { 'opacity-60 pointer-events-none': isLoading }
      )}
      {...getDataAutoTestAttributes(['button-add-email']).attributes}
    >
      <MaterialIcon className="text-[20px]">add_circle_outline</MaterialIcon>
      <div className="text-sm">Add email</div>
    </div>
  );

  return (
    <>
      {isLimitReached ? (
        <Tooltip
          content={<div className="text-xs">20 email addresses limit reached</div>}
          placement="top-start"
        >
          <span className="cursor-not-allowed opacity-60">{addEmailButton}</span>
        </Tooltip>
      ) : (
        <>{addEmailButton}</>
      )}
    </>
  );
}
